if ($('.display-posts-page').length ) {
    var page = 1,
        ppp = 5;

    $('.load-more').on("click", function(){
        $(this).attr("disabled", true);
        $.post(ajaxUrl, {
            action:"more_post_ajax",
            offset: (page * ppp) +1,
            ppp: ppp
        }).success(function(posts){
            page++;
            if( posts.length ) {
              $('.display-posts-con').append(posts);
              $('.load-more').attr("disabled", false);
            }
        });
    });

}



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_load-posts.js